import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '@data-phone/react-resource-server-auth';

export interface ActiveAgent {
  name: string;
  status: string;
  state: string;
}

export interface Member {
  uuid: string;
  agent: string;
  state: string;
  baseScore: string; 
  joinedEpoch: string; 
  sessionUUID: string;
  callerIDName: string;
  rejoinedEpoch: string; 
  callerIDNumber: string;
}

export interface Tier {
  agent: string;
  level: string;
  position: string;
  state: string;
}

export interface ActiveQueue {
  name: string;
  tiers: Tier[];
  members:Member[]
}

export interface ActiveAgentsResponse {
    agents?: ActiveAgent[] | null;
  queues?: ActiveQueue[] | null;
}

// Thunk: fetch call center active agents/queues
export const fetchActiveAgents = createAsyncThunk<ActiveAgentsResponse>(
  'activeAgents/fetchActiveAgents',
  async () => {
    const response = await api.get(`${process.env.REACT_APP_LIVE_CALL_URL}/api/callcenter/active`);
    const result = response.result;
    return result
  }
);
